const headerToggle = document.querySelector('.header__icons__toggle');
const spNav = document.querySelector('.nav');
const spClose = document.querySelector('.nav__close');
headerToggle.addEventListener('click', function(){
  spNav.classList.add('js-open');
});
  spClose.addEventListener('click', function(){
  spNav.classList.remove('js-open');
});

// ハンバーガーメニュー
$(function(){
  $('.navSp__modal__back').on('click', function () {
    $(this).parent().fadeOut();
  });
});

document.querySelectorAll('.navSp-link').forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    // 全てのコンテンツを非表示にする
    document.querySelectorAll('.navSp__modal').forEach(content => {
      content.style.display = 'none';
    });
    // クリックされたリンクに対応するコンテンツを表示
    const targetId = this.getAttribute('data-target');
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.style.display = 'block';
    }
  });
});

$(function() {
  var navLink = $('.sidebar__list li a');
  var contentsArr = new Array();
  for (var i = 0; i < navLink.length; i++) {
    var targetContents = navLink.eq(i).attr('href');
    if(targetContents.charAt(0) == '#') {
      if ($(targetContents).length) {
        var targetContentsTop = $(targetContents).offset().top - 200;
      }
      var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true) - 1;
      contentsArr[i] = [targetContentsTop, targetContentsBottom]
    }
  }
  function currentCheck() {
    var windowScrolltop = $(window).scrollTop();
    var docHeight = $(document).innerHeight(), //ドキュメントの高さ
      windowHeight = $(window).innerHeight(), //ウィンドウの高さ
      pageBottom = docHeight - windowHeight; //ドキュメントの高さ - ウィンドウの高さ
    if(pageBottom <= $(window).scrollTop()) {
      navLink.removeClass('js-current');
      navLink.eq(-1).addClass('js-current');
    } else{
      for (var i = 0; i < contentsArr.length; i++) {
        if(contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
          navLink.removeClass('js-current');
          navLink.eq(i).addClass('js-current');
          i == contentsArr.length;
        }
      }
    }
  }
  $(window).on('load scroll', function() {
    currentCheck();
  });
});
$(function(){
  $('a[href^="#"]:not(a.jdgm-write-rev-link):not(a.ly-languages-switcher-link)').click(function(){
    var speed = 500;
    var href= $(this).attr('href');
    var target = $(href == '#' ? 'html' : href);
    var position = target.offset().top - 120;
    $('html, body').animate({scrollTop:position}, speed, 'swing');
    return false;
  })
});

$(function(){
  //let windowHeight = $(window).height();
  $(window).on('scroll', function () {
    if (200 <= $(this).scrollTop()) {
      $('.header').addClass('js-scroll');
    } else {
      $('.header').removeClass('js-scroll');
    }
  });
});

$(function(){
  $('.information-bar__link').each(function(i){
    $(this).attr('class','header-news_' + (i+1));
  });
});


const elements = document.querySelectorAll('.section-description__content--main');
Array.from(elements).forEach(function(el){
  const btn = el.querySelector('.section-description__more');
  const content = el.querySelector('.section-description__text');
  btn.addEventListener('click', function(){
    if(!content.classList.contains('js-open')){
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('js-open');
      btn.remove();
    }
  });
});
